export const roomTypesColumns = (navigate) => [
  {
    Header: "ID",
    accessor: "id",
    width: "70px",
  },
  {
    Header: "Room Type",
    accessor: "room_type",
    width: "140px",
    Cell: ({ row }) => {
      const { room_type, badge } = row.original;

      const handleBadgeClick = () => {
        navigate(`/rooms/offers?room_type=${encodeURIComponent(room_type)}`);
      };

      return (
        <div>
          <div>{room_type}</div>
          {badge > 0 && (
            <span
              className="badge bg-success mt-1"
              style={{ cursor: "pointer" }}
              onClick={handleBadgeClick}
            >
              {badge} {badge === 1 ? "Offer" : "Offers"}
            </span>
          )}
        </div>
      );
    },
  },
  {
    Header: "Room Price",
    accessor: "room_price",
    width: "120px",
  },
  {
    Header: "Total Room",
    accessor: "total_rooms",
    width: "90px",
  },
  {
    Header: "Capacity",
    accessor: "capacity",
    width: "100px",
  },
  {
    Header: "Room Size",
    accessor: "room_size",
    width: "120px",
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
    width: "120px",
  },
];
